"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = (0, tslib_1.__importStar)(require("react"));
const elements_1 = require("../../elements");
const controller_1 = require("@incodocs/react/controller");
const FileUploadComponent = ({ startOpen = false, startMinimised = false, store, onUploadComplete }) => {
    const [open, setOpen] = (0, react_1.useState)(startOpen);
    const [minimised, setMinimised] = (0, react_1.useState)(startMinimised);
    const fileUploadState = (0, controller_1.useStore)(store);
    (0, react_1.useEffect)(() => {
        return store.subscribeToFileUploadComplete(file => {
            onUploadComplete(file, store);
        });
    }, [onUploadComplete]);
    (0, react_1.useEffect)(() => {
        if (fileUploadState.state.uploads.length > 0) {
            setOpen(true);
        }
    }, [fileUploadState.state.uploads]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleMinimiseMaximise = () => {
        setMinimised(m => {
            const newState = !m;
            fileUploadState.state.widgetMinimised = newState;
            return newState;
        });
    };
    var rows = (array) => {
        const items = [];
        array.forEach(element => {
            items.push((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "file-upload__details-item" }, { children: element.name }), void 0));
        });
        return items;
    };
    if (!open)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "file-upload" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "file-upload__status" }, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Uploading ", fileUploadState.state.uploads.length, " Item", fileUploadState.state.uploads.length > 1 && 's'] }, void 0), (0, jsx_runtime_1.jsx)("a", Object.assign({ onClick: handleMinimiseMaximise }, { children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "caretDown" }, void 0) }), void 0), (0, jsx_runtime_1.jsx)("a", Object.assign({ onClick: handleClose }, { children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "close" }, void 0) }), void 0)] }), void 0), !minimised && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "file-upload__details" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "file-upload__details-header" }, { children: [(0, jsx_runtime_1.jsxs)("p", { children: [fileUploadState.state.uploads.length, " upload", fileUploadState.state.uploads.length > 1 && 's', (fileUploadState.state.uploads.length = 0 && 's'), " left..."] }, void 0), (0, jsx_runtime_1.jsx)("a", { children: "Cancel" }, void 0)] }), void 0), rows(fileUploadState.state.uploads)] }), void 0))] }), void 0));
};
/**
 * FileUpload component
 *
 * @visibleName FileUpload
 */
class FileUpload extends react_1.default.Component {
    render() {
        return (0, jsx_runtime_1.jsx)(FileUploadComponent, Object.assign({}, this.props), void 0);
    }
}
exports.FileUpload = FileUpload;
//# sourceMappingURL=FileUpload.js.map